import { render, staticRenderFns } from "./KpiSatifaccionGerencia.vue?vue&type=template&id=60a4c710&"
import script from "./KpiSatifaccionGerencia.vue?vue&type=script&lang=js&"
export * from "./KpiSatifaccionGerencia.vue?vue&type=script&lang=js&"
import style0 from "./KpiSatifaccionGerencia.vue?vue&type=style&index=0&id=60a4c710&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports